<template>
  <div>
    <h4 class="mb-4 text-utel"><strong>Listado de planes empresariales</strong></h4>
    
    <v-data-table
      :headers="headers" 
      :items="plans" 
      item-key="id" 
      :page="currentPage"
      :items-per-page="itemsPerPage" 
      class="elevation-1 table text-center align-middle small" 
      :loading="loading"
      loading-text="Cargando..." 
      mobile-breakpoint="0" 
      :header-props="{ sortIcon: 'fa-solid fa-up-down' }"
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr class="text-center">
          <td>{{ item.id }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.clientes_activos }}</td>
          <td>{{ item.accepted_users }}</td>
          <td>{{ item.accepted_routes }}</td>
          <td>{{ item.accepted_courses }}</td>
          <td>{{ item.expiration_date }}</td>
          <td>
            <button 
              type="button" 
              class="btn bg-utel-v2-secondary p-2 m-1 px-3 rounded-pill text-primary me-1" 
              title="Editar plan" 
              @click="$emit('edit-plan', item)"
            >
              <i class="fa-solid fa-edit"></i>
            </button>
            <button 
              type="button" 
              class="btn bg-utel-v2-secondary p-2 m-1 px-3 rounded-pill text-primary" 
              title="Eliminar plan" 
              @click="$emit('delete-plan', item)"
            >
              <i class="fa-solid fa-trash"></i>
            </button>
          </td>
        </tr>
      </template>
    </v-data-table>

    <simple-pagination 
      :current-page="currentPage"
      :page-count="pageCount"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import SimplePagination from '../users/SimplePagination.vue'

export default {
  name: 'PlanTable',
  
  components: {
    SimplePagination
  },
  
  props: {
    plans: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    currentPage: { type: Number, default: 1 },
    pageCount: { type: Number, default: 1 },
    itemsPerPage: { type: Number, default: 10 }
  },
  
  emits: ['edit-plan', 'delete-plan', 'page-change'],
  
  computed: {
    headers() {
      return [
        { text: "#", value: "id", align: 'center' },
        { text: "Licencia", value: "name", align: 'center' },
        { text: "Empresas", value: "clients", align: 'center' },
        { text: "Usuarios disponibles", value: "accepted_users", align: 'center' },
        { text: "Rutas disponibles", value: "accepted_routes", align: 'center' },
        { text: "Cursos disponibles", value: "accepted_courses", align: 'center' },
        { text: "Tiempo de licencia", value: "expiration_date", align: 'center' },
        { text: "Opciones", value: "actions", sortable: false }
      ]
    }
  },
  
  methods: {
    handlePageChange(page) {
      this.$emit('page-change', page);
    }
  }
}
</script>

<style scoped>
.text-utel {
  color: #1A0054;
}
</style>